import { logger } from '@getvim/vim-connect-logger';
import { scopeName } from '../../consts';

export const orderAssistLogger = logger.scope(scopeName, {
  moduleName: 'Order Assist',
  moduleAndScopeSameColor: true,
});
